import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import reactHtmlParser from 'react-html-parser';
import { HomePageArticle } from '../../api/homePage/HomePageArticle';
import Page from '../../components/Page';
import PageHeadline from '../../components/PageHeadline';

export interface SeasonHintDetailPageLayoutProps extends StandardDivProps<SeasonHintDetailPageLayoutClassKey> {
  articleDetail: HomePageArticle;
}

export type SeasonHintDetailPageLayoutClassKey = 'root' | 'content';

const themeSettings = { name: 'SeasonHintDetailPageLayout' };
const useStyles = makeStyles(
  // (theme: Theme) =>
  createStyles<SeasonHintDetailPageLayoutClassKey, {}>({
    root: {},
    content: { display: 'flex', flexDirection: 'column', alignItems: 'stretch', width: '100%', overflow: 'hidden' },
  }),
  themeSettings,
);

const SeasonHintDetailPageLayout = React.forwardRef<HTMLDivElement, SeasonHintDetailPageLayoutProps>(
  ({ articleDetail, className, classes: pClasses }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const pageTitle = articleDetail.title;

    return (
      <Page ref={ref} className={clsx(classes.root, className)} pageTitle={pageTitle}>
        <PageHeadline>{pageTitle}</PageHeadline>
        {articleDetail?.body && <div className={classes.content}>{reactHtmlParser(articleDetail.body)}</div>}
      </Page>
    );
  },
);

SeasonHintDetailPageLayout.displayName = 'SeasonHintDetailPageLayout';

export default withThemeProps(themeSettings)(SeasonHintDetailPageLayout);
